import React from 'react'
import './Home.css';

const Home = ( { handleSeeMoreClick } ) => {

  return (
    <div className="landing-page">
      <section className="hero">
        <div className="hero-text">
          <h1>Empowering People. Transforming Society. Through Drones.</h1>
        </div>
      </section>
      
      <section className="models">
        <h2 className="section-title">Our Services</h2>
      </section>


      <div className="home_box light">
        <div className="home_box_hero">
          <div className="home_box_hero_left">
            <h1>Consultancy Services (PX4 & ArduPilot)</h1>
            <p>
              We provide end-to-end consultancy focused on multicopter drone systems, covering design, development, and optimization using PX4 and ArduPilot. Our expertise includes airframe selection, powertrain sizing, payload integration (such as spraying and sensors), and complete system configuration tailored for reliable multicopter performance.
            </p>

            <p>
              We support advanced flight stack customization, tuning, and feature development across PX4, ArduPilot, QGroundControl, and Mission Planner, including mission planning workflows and telemetry setup. Our services extend to integration with mapping and survey software for real-world operations.
            </p>

            <p>
              We specialize in integrating sensors and actuators such as LiDAR, GPS, and flow sensors using CAN, UART, 
              and I2C, along with custom driver development and companion computer integration for features like obstacle 
              avoidance and autonomy. We also provide deep debugging, flight log analysis, and performance optimization 
              to ensure stable and efficient multicopter systems. 
            </p>
          </div>
          <div className="home_box_hero_right">
            <img src="/images/Consultancy_Services.png" alt="Drone" />
          </div>
        </div>
      </div>


      <div className="home_box shaded">
        <div className="home_box_vision">
          <div className="home_box_vision_left">
            <img src="/images/Drone_Training.png" alt="Drone" />
          </div>
          <div className="home_box_vision_right">
            <h2>Workshops & Training (PX4 & ArduPilot)</h2>
            <p>
              Our hands-on workshops and training programs focus on multicopter drone building and operation, 
              providing practical experience using PX4 and ArduPilot. Participants learn to assemble multicopters, 
              integrate electronics, and prepare systems for safe and reliable flight.
            </p>

            <p>
              The training covers flight controller setup, PID tuning, flight testing, and use of QGroundControl and Mission 
              Planner for mission planning and execution. Participants also gain hands-on exposure to sensor integration, 
              telemetry setup, and structured debugging, including log analysis and troubleshooting.
            </p>

            <p>
              Advanced sessions introduce companion computers, autonomy concepts, and custom firmware workflows, 
              enabling participants to confidently build, tune, and extend multicopter drone systems. 
              These programs are ideal for students, professionals, and teams seeking strong practical expertise
              in real-world drone development.
            </p>
          </div>
        </div>
      </div>


      <div className="home_box light">
        <div className="home_box_hero">
          <div className="home_box_hero_left">
            <h1>Agricultural Spraying</h1>
            <p>
              Agricultural Spraying refers to the application of chemicals such as pesticides, 
              herbicides, fungicides, and fertilizers onto crops using various spraying equipment.
              This process helps protect plants from pests and diseases, promote healthy growth, 
              and increase crop yields.
            </p>

            <p> 
              Spraying can be performed using manual sprayers, 
              tractor-mounted systems, or advanced aerial methods like drones. 
              Proper spraying techniques ensure even coverage, minimize chemical waste, 
              and reduce environmental impact.
            </p>
          </div>
          <div className="home_box_hero_right">
            <img src="/images/Agricultural_Spraying_1.jpeg" alt="Drone" />
          </div>
        </div>
      </div>

      <div className="home_box shaded">
        <div className="home_box_vision">
          <div className="home_box_vision_left">
            <img src="/images/Mapping_1.jpeg" alt="Drone" />
          </div>
          <div className="home_box_vision_right">
            <h2>Survey & Mapping</h2>
            <p>
              Survey & Mapping involves the precise measurement and representation of 
              land features to create maps, plans, and spatial data. It plays a crucial 
              role in agriculture, construction, urban planning, and environmental management. 
            </p>

            <p> 
              Using tools like GPS, total stations, drones, and GIS software, surveyors 
              collect accurate data on land contours, boundaries, and infrastructure. 
              Mapping visualizes this data for analysis, planning, and decision-making.
            </p>
          </div>
        </div>
      </div>

      <div className="home_box light">
        <div className="home_box_hero">
          <div className="home_box_hero_left">
            <h1>Photography & Videography</h1>
            <p>
              Photography & Videography involve capturing visual content through images 
              and motion pictures to document, tell stories, or promote subjects. 
              Widely used in media, events, marketing, and creative industries, 
              they combine technical skill with artistic vision. With the use of 
              modern cameras, drones, and editing tools, high-quality visuals can be 
              produced for a variety of purposes including advertising, documentation, 
              entertainment, and education.
            </p>
          </div>
          <div className="home_box_hero_right">
            <img src="/images/Photography_Videography.jpeg" alt="Drone" />
          </div>
        </div>
      </div>

      <div className="home_box shaded">
        <div className="home_box_vision">
          <div className="home_box_vision_left">
            <img src="/images/Security_1.jpg" alt="Drone" />
          </div>
          <div className="home_box_vision_right">
            <h2>Surveillance</h2>
            <p>
              Surveillance is the continuous observation and monitoring of activities, behaviors, 
              or environments to gather information, enhance security, and ensure safety. 
            </p>

            <p>
              It is widely used in areas such as law enforcement, public safety, industrial operations, 
              and agriculture. Surveillance can be carried out using cameras, sensors, drones, 
              or automated systems, enabling real-time tracking and recording for threat detection, 
              operational monitoring, and evidence collection.
            </p>
          </div>
        </div>
      </div>

      <section className="key-features">
        <h2> Our Drone Features </h2>
        <div className="features">
          <div className="feature-item">
            <img src="/images/battery.png" alt='battery'/>
            <h3>Long Battery Life</h3>
            <p>Fly longer with 30 minutes of flight time</p>
          </div>

          <div className="feature-item">
          <img src="/images/High_Quality_Camera.png" alt='Camera'/>
            <h3>High Quality Camera</h3>
            <p>Capture stunning 4k footage from the sky</p>
          </div>

          <div className="feature-item">
          <img src="/images/Obstacle_Avoidance.png" alt='Avoidance'/>
            <h3>Obstacle Avoidance</h3>
            <p>stay safe with intelligent flight technology</p>
          </div>

          <div className="feature-item">
          <img src="/images/Easy_to_use_control.png" alt='control'/>
            <h3>Easy-to-use-control</h3>
            <p>No Experience is required-fly with confidence</p>
          </div>
        </div>
      </section>


      {/* <section className="testimonials">
        <h2>What Our Customer Say</h2>
        <div className="testimonial">
          <p>"The drone is super easy to fly, and the footage is amazing!"</p>
        </div>
      </section> */}
    </div>
  )
}

export default Home;
